import React from "react";
import "./DownloadList.scss";
import { useTranslation } from "react-i18next";

function DownloadList({
  onDownloadPlain,
  onDownloadWithDescriptions,
  onCancel,
}) {
  const { t } = useTranslation();
  return (
    <div className="download-list-content">
      <div className="title">
        <span>{t("lists.modals.download.title")}</span>
        <button className="close-button" onClick={onCancel}>
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>

      <div className="download-options">
        <button className="download-option-btn" onClick={onDownloadPlain}>
          <span className="material-symbols-outlined">description</span>
          <div className="option-text">
            <span className="option-title">
              {t("lists.modals.download.plain")}
            </span>
            <span className="option-description">
              {t("lists.modals.download.plainDescription")}
            </span>
          </div>
        </button>

        <button
          className="download-option-btn"
          onClick={onDownloadWithDescriptions}
        >
          <span className="material-symbols-outlined">article</span>
          <div className="option-text">
            <span className="option-title">
              {t("lists.modals.download.withDescriptions")}
            </span>
            <span className="option-description">
              {t("lists.modals.download.withDescriptionsDescription")}
            </span>
          </div>
        </button>
      </div>
    </div>
  );
}

export default DownloadList;
